import moment from "moment";
import Company from "../../../app/domain/Company";
import BenefitPlan from "../../../app/domain/BenefitPlan";
import { MonetaryAmount } from "../../../app/domain/monetary-amount";
import Employee from "../../../app/domain/Employee";

export default function adaptEmployeesForBagInclusion({
  company,
  benefitPlan,
  amount,
  date,
  employees,
}: {
  company: Company;
  benefitPlan: BenefitPlan;
  amount: MonetaryAmount;
  date: Date;
  employees: Employee[];
}) {
  return {
    companyId: company.id,
    benefitPlanId: benefitPlan.id,
    benefitBagConfigId: benefitPlan.benefitBag.id,
    consumableFrom: moment(date).format("YYYY-MM-DD"),
    limitAmount: amount,
    employeeIds: employees.map(({ id }) => id),
  };
}
